import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type CodemirrorEditorVue3 from './codemirror-editor-vue3.vue'

export const codemirrorEditorVue3Props = buildProps({
  // buildProps和defineprops一样
  /**
   * @description code
   */
  value: {
    type: String,
    default: '',
  },
  /**
   * @description 语言/主题等配置
   */
  options: {
    type: definePropType<any>(Object),
  },
  /**
   * @description 内容为空的占位符
   */
  placeholder: {
    type: String,
    default: '',
  },
  /**
   * @description 是否显示边框
   */
  border: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 宽度
   */
  width: {
    type: String,
    default: '100%',
  },
  /**
   * @description 高度
   */
  height: {
    type: String,
    default: '100%',
  },
  /**
   * @description 使用原来的样式，禁用该组件的样式的第二次修改（但不影响宽度、高度和边框）
   */
  originalStyle: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 始终将鼠标位置保持在最后一行
   */
  KeepCursorInEnd: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 合并模式，也可以用作 diff 模式
   */
  merge: {
    type: Boolean,
    default: false,
  },
} as const)
export const codemirrorEditorVue3Emits = {
  'update:value': (v) => !!v,
  change: (v) => !!v,
  blur: (codeMirror, e) => codeMirror && e,
  focus: (codeMirror, e) => codeMirror && e,
  scroll: (codeMirror) => !!codeMirror,
  keyup: (codeMirror, e) => codeMirror && e,
}

// props
export type CodemirrorEditorVue3Props = ExtractPropTypes<
  typeof CodemirrorEditorVue3
> // ExtractPropTypes和defineCpmponent类似

// instance
export type CodemirrorEditorVue3Instance = InstanceType<
  typeof CodemirrorEditorVue3
>
